export default "__VITE_ASSET__DKdM4tsr__"